import { inject, Injectable } from '@angular/core';
import { StoreService } from '../store/store.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import {
  IRedirectionConfig,
  IUserInfo,
  Products,
} from 'src/app/interfaces/state-interface';
import { CookiesService } from '../cookies/cookies.service';
import { NS_Enums } from 'src/app/static/namespace';
import { Token } from 'src/app/app.model';
import { AppService } from '../app.service';
import { PUBLIC_LINKS } from 'src/app/static/api.constant';

@Injectable({
  providedIn: 'root',
})
export class RedirectionService {
  private store: StoreService = inject(StoreService);
  private cacheService: CookiesService = inject(CookiesService);
  private appService: AppService = inject(AppService);
  private router: Router = inject(Router);

  constructor() {}

  redirectToProduct(
    customRedirectURL: string = '',
    options?: IRedirectionConfig
  ) {
    try {
      // const customToken: string = this.store.getCustomToken();
      const token: string = this.store.getToken();
      const userInfo: any = JSON.stringify(this.store.getUser());

      /* Get Custom Token */

      const product: any = this.store.getProduct();
      if (product === 'SARAS' && !options?.currentProduct) {
        this.appService.$showWelcomeView.next(true);
        setTimeout(() => {
          this.appService.$showWelcomeView.next(false);
          this.router.navigate(['/products']);
        }, 3000);
        return;
      }
      if (token) {
        const encryptedToken = token && btoa(token);
        const encryptedUserInfo = userInfo && btoa(userInfo);
        const url = new URL(
          customRedirectURL || this.getRedirectionUrl(product)
        );
        const usp = new URLSearchParams();
        usp.set('token', encryptedToken);
        usp.set('user', encryptedUserInfo);
        this.appService.recorrectSarasGlobalCookie();
        if (!!options?.params?.length) {
          options?.params.forEach((param) => {
            usp.set(param.key, param.value);
          });
        }
        url.search = usp.toString();
        if (options?.newTab) {
          // @ts-ignore
          window.open(url, '_blank')?.focus();
        } else {
          // @ts-ignore
          window.location = url.href;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  redirectByProductName(productName: Products, config?: IRedirectionConfig) {
    const redirectionUrl = this.isLocal
      ? productName === Products.IQ
        ? 'http://localhost:3001/auth'
        : 'http://localhost:4300/auth'
      : environment.PRODUCTS[productName];
    this.redirectToProduct(redirectionUrl, {
      currentProduct: productName,
      newTab: true,
      ...(config || {}),
    });
  }

  redirectToProdeuctPricing(productName: Products) {
    const redirectionUrl = this.isLocal
      ? 'http://localhost:4300/auth'
      : environment.PRODUCTS[productName];
    const redirectParamUrl = this.isLocal
      ? `http://localhost:4300/${
          productName === Products.DATON ? 'u/pricing' : 'subscription/overview'
        }`
      : environment.PRODUCT_PRICING[productName];

    this.redirectToProduct(redirectionUrl, {
      currentProduct: productName,
      newTab: true,
      params: [{ key: 'redirectTo', value: redirectParamUrl }],
    });
  }

  redirectToScheduleDemo() {
    window.open(PUBLIC_LINKS.BOOK_DEMO, '_blank')?.focus();
  }

  private getRedirectionUrl(product: any) {
    if (this.isLocal) {
      if (product === Products.IQ) {
        return 'http://localhost:3001/auth';
      }
      return 'http://localhost:4300/auth';
    }

    const products: any = environment.PRODUCTS;
    return product ? products[product] : environment.PRODUCTS.SARAS;
  }

  private get isLocal() {
    return (
      location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    );
  }
}
